import { ICMSService } from "./ICMSService"
import ApiUtils from "../ApiUtils"
import { BlogElement, IFetchAllBlogsPayload, IFetchAllBlogsRes, IFetchAllInfoBitesRes, IFetchCMSNonBlogCategoriesRes, ISearchBlogsPayload } from "./CMSServiceModels"

export const CMSUrls = {
	fetchAllBlog: `/blog/all`,
	fetchAllInfoBites: `/info-bites/all`,
	searchBlogs: (searchText: string, blogType: string) => `/blog/search/title?searchText=${searchText}&blogType=${blogType}`,
	fetchNonBlogCategories: `/category/all?isNonBlogCategoryRequired=false`,
}
export default class CMSServiceApis implements ICMSService {
	getServiceUrl = (url: string) => `/sugarfit-cms${url}`
	fetchAllBlogs(payload: IFetchAllBlogsPayload): Promise<IFetchAllBlogsRes> {
		return ApiUtils.post(this.getServiceUrl(CMSUrls.fetchAllBlog), payload)
	}

	fetchAllInfoBites(): Promise<IFetchAllInfoBitesRes[]> {
		return ApiUtils.get(this.getServiceUrl(CMSUrls.fetchAllInfoBites))
	}

	searchBlogs(payload: ISearchBlogsPayload): Promise<BlogElement[]> {
		const { searchText, blogType } = payload
		return ApiUtils.get(this.getServiceUrl(this.getServiceUrl(CMSUrls.searchBlogs(searchText, blogType))))
	}

	fetchCMSNonBlogCategories(): Promise<IFetchCMSNonBlogCategoriesRes[]> {
		return ApiUtils.get(this.getServiceUrl(CMSUrls.fetchNonBlogCategories))
	}
}
